var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBriefcaseMedical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M464 96H384V48C384 21.5 362.5 0 336 0H176C149.5 0 128 21.5 128 48V96H48C21.5 96 0 117.5 0 144V432C0 458.5 21.5 480 48 480H464C490.5 480 512 458.5 512 432V144C512 117.5 490.5 96 464 96ZM176 48H336V96H176V48ZM368 314C368 322.836 360.836 330 352 330H298V384C298 392.836 290.836 400 282 400H230C221.164 400 214 392.836 214 384V330H160C151.164 330 144 322.836 144 314V262C144 253.162 151.164 246 160 246H214V192C214 183.162 221.164 176 230 176H282C290.836 176 298 183.162 298 192V246H352C360.836 246 368 253.162 368 262V314Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseMedical);
export default __webpack_public_path__ + "static/media/briefcase-medical.aad108cdff5094026e02486acedb56bd.svg";
export { ForwardRef as ReactComponent };